module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"reset":"Remise à zéro"}}')
  delete Component.options._Ctor
}
